// src/pages/Signin.jsx
import React, { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import Footer from "../components/Footer";
import PageHeader from "../components/Auth/PageHeader";
import SignIn from "../components/Auth/SignIn";

const Signin = () => {
  // Use useMediaQuery to detect if the screen size is mobile
  const isMobile = useMediaQuery('(max-width: 990px)');
  const location = useLocation();

  useEffect(() => {
    // Check for verification success message from state
    if (location.state?.message) {
      // Store in localStorage to show after page load
      localStorage.setItem('loginMessage', JSON.stringify({
        message: location.state.message,
        severity: location.state.severity || 'success'
      }));
    }

    // Check for verification message from location state
    if (location.state?.message) {
      // Store in sessionStorage as backup
      sessionStorage.setItem('loginMessage', JSON.stringify({
        message: location.state.message,
        severity: location.state.severity || 'success'
      }));
    }
  }, [location]);

  return (
    <div>
      {!isMobile && <Header />} {/* Render Header only on desktop view */}
      {isMobile && <MobileHeader />} {/* Render MobileHeader only on mobile view */}
      <PageHeader
        title="Sign In"
        breadcrumbs={[{ label: "Home", link: "/" }, { label: "Sign In" }]}
      />
      <SignIn />
      <Footer />
    </div>
  );
};

export default Signin;